// File: src/hooks/useUrlParams.js
// خواندن و نوشتن پارامترهای URL (tab و tag) برای SPA

import { useState, useEffect, useCallback } from 'react';

/* خواندن یک پارامتر از query string فعلی */
export function getUrlParam(key) {
  try {
    return new URLSearchParams(window.location.search).get(key) || '';
  } catch {
    return '';
  }
}

/* تنظیم پارامترهای URL بدون reload صفحه (history.pushState) */
export function setUrlParams(params = {}, replace = false) {
  try {
    const url = new URL(window.location.href);
    Object.entries(params).forEach(([k, v]) => {
      if (v === '' || v === null || v === undefined) url.searchParams.delete(k);
      else url.searchParams.set(k, v);
    });
    const method = replace ? 'replaceState' : 'pushState';
    window.history[method]({}, '', url.toString());
  } catch {}
}

/* hook: مقدار یک پارامتر URL را به‌صورت state بده و با back/forward هماهنگ بمان */
export function useUrlParam(key, fallback = '') {
  const [value, setValue] = useState(() => getUrlParam(key) || fallback);

  useEffect(() => {
    const onPop = () => setValue(getUrlParam(key) || fallback);
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, [key, fallback]);

  const update = useCallback((v, replace = false) => {
    setValue(v || fallback);
    setUrlParams({ [key]: v }, replace);
  }, [key, fallback]);

  return [value, update];
}
